/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateMaterialDto = {
    /**
     * Material name
     */
    name: string;
    /**
     * Material description
     */
    description?: string;
    /**
     * Source of creation
     */
    source?: CreateMaterialDto.source;
};
export namespace CreateMaterialDto {
    /**
     * Source of creation
     */
    export enum source {
        CATALOG = 'CATALOG',
        SETTINGS = 'SETTINGS',
    }
}

